<template>
  <div>
    <div class="park_enterprise_box" v-if="Flage">
      <div class="park_enterprise_box_width flex">
        <div class="park_enterprise_left">
          <h4 class="park_enterprise_title">
            {{ swiperInfo.enterpriseName }}
          </h4>
          <p class="park_enterprise_mess">
            {{ swiperInfo.details }}
          </p>
          <div class="park_enterprise_button flex">
            <button
              class="flex"
              v-if="swiperInfo.vrList != null && swiperInfo.vrList.length > 0"
              @click="goToEnterpriseVeiws(swiperInfo)"
            >
              <i class="iconfont">&#xe635;</i>
              VR全景
            </button>
            <button
              class="flex"
              v-else
              style="color: #9a9a9a; border: 1px solid #9a9a9a"
              @click="goToEnterpriseVeiws(swiperInfo)"
            >
              <i class="iconfont">&#xe635;</i>
              VR全景
            </button>
          </div>
        </div>
        <div class="park_enterprise_img" v-if="swiperInfo.thumbnail != ''">
          <img :src="swiperInfo.thumbnail" alt="" />
        </div>
		<div v-else class="park_enterprise_img">
			该园区未上传图片
		</div>
      </div>
    </div>
    <!-- Swiper -->
    <div class="swiper-container" v-if="Flage">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(items, index) in swiperList"
          :key="index"
        >
          <div class="park_swipers"  @mouseover="updateSwiperInfo(index)">
            <div class="park_swipers_img">
              <img
			  v-if="items.thumbnail !=''"
                :src="items.thumbnail"
                alt=""
               
                class="park_car_img"
              />
			 <div class="park_car_img" v-else>
			 	该园区未上传图片
			 </div>
            </div>
            <p>{{ items.enterpriseName }}</p>
          </div>
        </div>
      </div>

      <div class="swiper-button-prev" @click="prevSwiperInfo"></div>
      <div class="swiper-button-next" @click="nextSwiperInfo"></div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { mapState } from "vuex";
import { getEnterpriseMangeList } from "../../utils/interface";
export default {
  name: "swiper",
  components: {},
  data() {
    return {
      swiperIndex: 0,
      parkId: "",
      current: 1,
      pageSize: 10,
      effect: 0,
      slides: ["Slide 1", "Slide 2", "Slide 3", "Slide 4", "Slide 5"],
      swiperList: [],
      swiperInfo: {},
      setIn: null,
	  Flage:true,
    };
  },
  mounted(){
  },
	created() {
    this.parkId = this.$route.params.uuid;
	console.log(this.isTokenDoor)
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
		  clearInterval(this.setIn);
		  // console.log(this.swiperList ,'初始化之前的值')
        this.getEnterpriseMangeList();
		// console.log(this.swiperList ,'初始化之后的值')
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  methods: {
    getEnterpriseMangeList() {
      let params = {
        parkId: this.parkId,
        current: this.current,
        pageSize: this.pageSize
      };
      getEnterpriseMangeList(params).then((res) => {
        if (res.list.length > 0) {
          this.swiperList = res.list;
		  console.log(this.swiperList ,'获取到的值')
          // this.swiperInfo = this.swiperList[0];
		  this.swiperInfo = res.list[0];
          this.$nextTick(() => {
          //   // 进行初始化 延迟执行，确保数据已经渲染完成
            this.handSwiper();
          });
        }else{
			this.Flage = false
		}
      });
    },
	mouseoutSwiperInfo(index){
		console.log(index)
	},
    updateSwiperInfo(index) {
      this.swiperIndex = index;
      this.swiperInfo = this.swiperList[index];
	 
    },
    prevSwiperInfo() {
      // console.log(this.swiperIndex);
      if (this.swiperIndex > 0) {
        this.swiperIndex = this.swiperIndex - 1;
        this.swiperInfo = this.swiperList[this.swiperIndex];
      }
    },
    nextSwiperInfo() {
      console.log(this.swiperIndex);
      console.log(this.swiperList.length);

      if (this.swiperIndex < this.swiperList.length - 1) {
        this.swiperIndex = this.swiperIndex + 1;
        this.swiperInfo = this.swiperList[this.swiperIndex];
      }else{
		  this.swiperIndex = 0;
		  this.swiperInfo = this.swiperList[this.swiperIndex];
	  }
	 
    },

    handSwiper() {
      // let _this = this;
      let effectIn = this.effect;
      let mySwiper = new Swiper(".swiper-container", {
        // slidesPerView: 4,
        // spaceBetween: 30,
        // loop: true,
        // watchSlidesProgress: true,
        // observer: true,
        // observeParents: true,
        // slideToClickedSlide: true,
        initialSlide: 0,
        loop: true,
        loopAdditionalSlides: 3,
        speed: 1000,
        slidesPerView: 4,
        spaceBetween: 30,
        centeredSlides: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        on: {
          slideChange: function () {
			  // this.mouseoutSwiperInfo()
            // this.swiperInfo = this.swiperList[this.swiperIndex];
          },
          setTranslate() {
            let slides = this.slides;
            for (var i = 0; i < slides.length; i++) {
              let slide = slides.eq(i);
              let progress = slides[i].progress;
              //slide.html(progress.toFixed(2)); 看清楚progress是怎么变化的
              slide.css({ opacity: "", background: "" });
              slide.transform(""); //清除样式
              if (effectIn == 1) {
                slide.transform("scale(" + (1 - Math.abs(progress) / 8) + ")");
              }
            }
          },
          setTransition(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
          /*      slideChangeTransitionEnd: function(){
            _this.swiperInfo = _this.swiperList[this.activeIndex];
          },
          slideNextTransitionEnd: function(){
            _this.swiperInfo = _this.swiperList[this.activeIndex];
          },
          slidePrevTransitionEnd: function(){
            _this.swiperInfo = _this.swiperList[this.activeIndex];
          }*/
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 1500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          autoplayDisableOnInteraction: false,
        },
      });
      //鼠标覆盖停止自动切换
      mySwiper.el.onmouseover = function () {
        mySwiper.autoplay.stop();
      };

      //鼠标离开开始自动切换
      mySwiper.el.onmouseout = function () {
        mySwiper.autoplay.start();
      };
    },
    goToEnterpriseVeiws(info) {
      // console.log("goToEnterpriseVeiws",info);
      // if(info.enterpriseName == '共享智能装备（安徽）有限公司'){
      //   window.open("http://3dprinter.kocelcloud.com/","_blank")
      //   return;
      // }
      // if(info.enterpriseName == '运城市盐湖区财惠企业管理咨询服务有限公司（安徽）有限公司'){
      //   window.open("/zengcaicloudVideo","_blank")
      //   return;
      // }
	  if (info.vrUrl != null ) {
		  let routeData = this.$router.resolve({
		    name: "VeiwsUrl",
		    query: {
		      url: info.vrUrl
		    }
		  });
		  window.open(routeData.href, "_blank");
		  // let routeData = this.$router.resolve({
		  //   name: "enterpriseVeiws",
		  //   params: { uuid: info.uuid },
		  // });
		  // window.open(routeData.href, "_blank");
	  } else if (info.vrList != null && info.vrList.length > 0) {
          let routeData = this.$router.resolve({
            name: "enterpriseVeiws",
            params: { uuid: info.uuid },
          });
          window.open(routeData.href, "_blank");
        }else {
		  return this.$message.warning('该企业未上传vr信息')
	    
	  }
      // if (info.vrList == null || info.vrList.length <= 0) {
      //   return;
      // } else {
      //   let routeData = this.$router.resolve({
      //     name: "enterpriseVeiws",
      //     params: { uuid: info.uuid },
      //   });
      //   window.open(routeData.href, "_blank");
      // }
    },
  },
};
</script>

<style scoped lang="less">
.swiper-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding: 40px 0 90px;
}
.swiper-wrapper {
  width: 1200px;
  margin: 0 auto;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 200px;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition-property: all;
  margin-right: 0 !important;
}
.park_car_img {
  cursor: pointer;
  width: 100%;
  height: 200px;
  line-height: 123px;
  text-align: center;
  font-size: 14px;
  // background: #009999;
  border-radius: 10px;
}
.park_swipers {
  .park_swipers_img {
    background: #efefef;
    width: 220px;
    height: 123px;
    border-radius: 10px;
    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }

  p {
    font-size: 13px;
    color: #777;
    margin-top: 10px;
  }
}
// .swiper-wrapper {
//   width: 1200px;
//   margin: 0 auto;
// }
.swiper-slide {
  height: 100%;
  border-radius: 10px;
  background: none;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0;
  height: 45px;
  --swiper-navigation-size: 26px !important;
  top: 32%;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0px;

  height: 45px;
  --swiper-navigation-size: 26px !important;
  top: 32%;
}
.park_enterprise_box {
  background: #fafcff;
  .park_enterprise_box_width {
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    .park_enterprise_left {
      width: 500px;
      position: relative;
      .park_enterprise_title {
        margin-bottom: 10px;
      }
      .park_enterprise_mess {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 11;
        // height: 279px;
        // overflow-y: scroll;
        font-size: 13px;
        color: #777;
        line-height: 25px;
        text-indent: 2em;
        cursor: default;
      }
      // .park_enterprise_mess:hover::-webkit-scrollbar {
      //   overflow-y: scroll;
      //   width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      //   height: 10px;

      // }
      // ::-webkit-scrollbar-thumb {
      //   /*滚动条里面小方块*/
      //   border-radius: 10px;
      //   box-shadow: inset 0 0 5px rgba(205, 205, 205, 0.564);
      //   background: rgba(205, 205, 205, 0.564);
      // }
      .park_enterprise_mess:nth-child(3) {
        margin-top: 20px;
      }
      .park_enterprise_button {
        position: absolute;
        bottom: 0;
        font-size: 13px;
        button {
          align-items: center;
          color: #009999;
          border: 1px solid #009999;
          background: none;
          padding: 2px 6px;
          border-radius: 5px;
          margin-right: 10px;
          cursor: pointer;
          i {
            margin-right: 5px;
          }
        }
      }
    }
    .park_enterprise_img {
      width: 660px;
      height: 370px;
      background: #fff;
      border-radius: 10px;
	  text-align: center;
	  font-size: 20px;
	  line-height: 370px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parkSwiper/parkSwiper.vue